import { render, staticRenderFns } from "./PopoverVerifyCustomer.vue?vue&type=template&id=65664a0a&"
import script from "./PopoverVerifyCustomer.vue?vue&type=script&lang=ts&"
export * from "./PopoverVerifyCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./PopoverVerifyCustomer.vue?vue&type=style&index=0&id=65664a0a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports